import { css } from "lit";

export default css`
    :host {
        display: flex;
        align-items: center;
        gap: 2px;
        box-sizing: border-box;
        position: relative;
        width: var(--fields-pane-field-width);
        height: var(--fields-pane-field-height);
        margin-left: 2px;
        margin-top: 1px;
        padding-left: 2px;
        background: var(--fields-pane-field-background);
        border: var(--fields-pane-field-border);
        border-radius: var(--fields-pane-radius);
        font-family: var(--fields-pane-font-family);
        font-size: var(--fields-pane-font-size);
        white-space: nowrap;
    }

    :host(:hover) {
        background: var(--fields-pane-field-hover-background);
    }

    :host([movable]) {
        cursor: pointer;
        touch-action: none;
        -webkit-user-select: none;
        user-select: none;
    }

    input {
        flex: none;
        margin: 0;
    }

    input:disabled {
        opacity: 0.5;
    }

    .kind {
        flex: none;
        width: 16px;
        text-align: center;
        font-size: 8px;
        color: var(--fields-pane-marker-color);
    }

    .kind svg {
        display: block;
        width: 12px;
        height: 8px;
        margin: 0 auto;
        fill: none;
        stroke: currentcolor;
        stroke-width: 0.8;
        /* a crisp 1px line reads darker than the anti-aliased 8px letters; fade it to match */
        opacity: 0.75;
    }

    .label {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .remove {
        flex: none;
        width: 16px;
        height: 16px;
        margin-right: 2px;
        padding: 0;
        border: 0;
        background: transparent;
        color: var(--fields-pane-marker-color);
        font-size: 14px;
        line-height: 16px;
        cursor: pointer;
    }

    .remove:hover {
        color: inherit;
    }

    :host([kind="values"]) .label {
        font-weight: 700;
    }

    :host([nested]) {
        width: calc(var(--fields-pane-field-width) - 16px);
        margin-left: 18px;
    }

    :host([insertion="before"]) {
        box-shadow: 0 -2px 0 0 var(--fields-pane-insertion-color);
    }

    :host([insertion="after"]) {
        box-shadow: 0 2px 0 0 var(--fields-pane-insertion-color);
    }
`;
